if (window.location.pathname.includes("/collections/regalos-para-el")) {
  console.log("not running infinite scroll function");
} else {
  document.addEventListener("DOMContentLoaded", function() {
    console.log('infinite scroll function')
    infiniteScrollCollection();
    // enableSliderImages();
  });

  function enableSliderImages() {
    const swiperElements = document.querySelectorAll("swiper-container");

    swiperElements.forEach((swiperEl) => {
      swiperEl.addEventListener("swiperprogress", (event) => {
        const [swiper, progress] = event.detail;
      });

      swiperEl.addEventListener("swiperslidechange", (event) => {
        console.log("slide changed");
        swiperEl.querySelector(".card__inner .swiper-slide:not(:first-of-type").style.display = "block";
      });
    });
  }
  
  function infiniteScrollCollection() {
    var endlessScroll = new Ajaxinate({
      container: "#product-grid",
      pagination: "#AjaxinatePagination",
      method: "scroll",
      loadingText: "",
      offset: window.innerHeight * 5,
    });
  }
  
  jQueryinterval = setInterval(function () {
    // wait for jQuery to load & run script after jQuery has loaded
    if (window.jQuery) {
      var snapbackCache = SnapbackCache({
        bodySelector: "#collection-products",
      });
  
      jQuery(document).on("click", "#product-grid .card-wrapper", function (e) {
        snapbackCache.cachePage();
      });
  
      jQuery(document).on("snapback-cache:loaded", function (e, cachedPage) {
        infiniteScrollCollection();
        window.scrollTo(0, cachedPage.positionY);
      });
  
      $(window).bind("beforeunload", function () {
        snapbackCache.cachePage();
      });
    }
    
    clearInterval(jQueryinterval);
  }, 500);
}
